/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedaccount",
	_who: "",
	_group: "",
	_who_tracker: null,
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,
	listen_for_changes: listen_for_changes,
	load_person
});

/**
 * Listen for when one should open/close the managed user's info
 * @return {Object} Map of triggers to handlers
 */
function triggers() {
	return {
		"open": manage_person,
		"close": clear_managed,
		"load": load_person
	};
}

function listeners() {
	return {
		"management:managementremoved": refresh,
	};
}

/**
 * Set up the tracker, private vars, push initial state
 */
function init() {
	this._who = "";
	this._who_tracker = this.dispatcher.createTracker();

	this.push({
		data: {},
		open: false
	});
}

/**
 * Clear private variables, tracker
 */
function uninit() {
	this._who = "";
	this._who_tracker.off();
	this._who_tracker = null;
}

function manage_person(data) {
	var who = data.who;
	if (who === this._who) return;

	// Don't re-load if already loaded
	if (this.data.open && this.data.data._id === who)
		return this.dispatch("opened", this.data.data);

	this.load_person(data, true);

	this.emit("usermetrics:trigger:track", "view managed user's profile", {
		who,
	});
}

function load_person(data, shouldOpen){
	const who = data.who;
	const group = data.group;
	if (who === this._who) return;
	this._group = group;

	this.emit("save:trigger:start");
	this.api.manage
		.data(who, group)
		.then(handle_successful_manage.bind(this, shouldOpen))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this));

	// TODO: Probably make this a bit nicer
	this.emit("manageddefinitionworkflow:trigger:load", {
		who,
		group
	});
}

function finish_save() {
	this.emit("save:trigger:finish");
}

/**
 * Clears the currently managed person's data.
 */
function clear_managed() {
	this._who = undefined;
	this._group = undefined;
	this._who_tracker.off();
	this.push({
		data: {},
		group: null,
		open: false
	});

	this.emit("managedpatientgroups:trigger:reset");
	this.emit("manageddefinitionworkflow:trigger:reset");
	this.emit("managedresources:trigger:reset");
}

/**
 * Called on a successful "open" call. Listens for changes, extends state with data
 * @param  {Object} data The personal data of the managed person
 */
function handle_successful_manage(shouldOpen, data) {
	var id = data._id;
	if (this._who === id) return;
	this._who = id;

	this.listen_for_changes(id);

	const group = this._group;

	this.extend({
		open: true,
		group,
		data
	});

	this.emit("managedresources:trigger:load", {
		who: this._who,
		group
	});

	if(shouldOpen)
		this.dispatch("opened", data);
}

/**
 * Handles updates to the managed person's data. Extends the state
 * @param  {Object} data The person's personal data
 */
function handle_data_update(data) {
	this.extend({
		data: data
	});
}

/**
 * Refreshes the currently tracked managed person's personal data
 */
function refresh() {
	const id = this._who;
	const group = this._group;
	if (!id) return;
	return this.api.manage
		.data(id, group)
		.then(handle_data_update.bind(this));
}

/**
 * Listens for changes in a person's data. Clears previous trackers
 * @param  {String} who Id of managed person to track
 */
function listen_for_changes(who) {
	var tracker = this._who_tracker;
	var group = this._group;
	tracker.off();

	if(group){
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/settings", refresh.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/careplan/patient/updated", refresh.bind(this));
	} else {
		tracker.on("mqtt:u/" + who + "/settings", refresh.bind(this));
		tracker.on("mqtt:u/" + who + "/careplan/patient/updated", refresh.bind(this));
	}
}
